export default __webpack_public_path__ + "static/media/appbar-logo.3f24fbc0.png";